import { translates } from './translate';

export const errorOrders: Record<string, {
  label: string;
  redirect : boolean;
}> = {
  'not-inventory-product' : {label : translates.notInventoryProduct, redirect : false},
  table_name_exist: {label :translates.tableNameExist, redirect : false},
  'not-have-ingredients-to-all-products':{label : translates.notHaveIngredientsToAllProducts, redirect : true},
  'error-quantity': {label : translates.errorQuantity, redirect : true},
  'not-found-open-cash-register': {label :translates.notFoundOpenCashRegister, redirect : true},
  'no_cash_register_open': {label :translates.notFoundOpenCashRegister, redirect : true},
  'order-in-progress': {label :translates.orderInProgress, redirect : true},
};

export const errorFacture: Record<string, string> = {
  'invalid-pay': translates.invalidPay,
};

export const errorCashRegister: Record<string, string> = {
  cash_register_open: translates.alreadyOpenCashRegister,
  'error-no-permissions': translates.errorNoPermissions,
  'not-found-open-cash-register': translates.notFoundOpenCashRegister,
  'not-enough-cash': translates.notEnoughCash,
  'difference-cash-close-register': translates.differenceCashCloseRegister,
};

export const warningCashRegister: Record<string, string> = {
  'exist-open-cash': translates.alreadyOpenCashRegister,
};

export const errorAuth: Record<string, string> = {
  'invalid-credentials': translates.invalidCredentials,
  'auth/invalid-login-credentials': translates.invalidCredentials,
  'user-not-found': translates.userNotFound,
  'user-disabled': translates.userDisabled,
  'email-already-exists': translates.emailAlreadyExists,
  'phone-already-exists': translates.phoneAlreadyExists,
  'invalid-phone': translates.invalidPhone,
  'invalid-email': translates.invalidEmail,
  'invalid-password': translates.invalidPassword,
  'invalid-username': translates.invalidUsername,
  'invalid-name': translates.invalidName,
  'invalid-lastname': translates.invalidLastname,
  'auth/invalid-credentials': translates.authInvalidCredentials,
  'auth/user-disabled': translates.authUserDisabled,
  'auth/wrong-password': translates.authWrongPassword,
  'auth/user-not-found': translates.authUserNotFound,
  'auth/email-already-exists': translates.authEmailAlreadyExists,
};

export const errorUser: Record<string, string> = {
  'auth/phone-already-exists': translates.phoneAlreadyExists,
}
